import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./product_card.module.css";
import productImage from "../../images/product_1.png";
import { ReactComponent as Star } from "../../images/star.svg";
import { useSelector, useDispatch } from "react-redux";
import { getUser, getCart, getFavorites, getSettings } from "../../services/selectors";
import { ADD_PRODUCT_TO_CART, putSyncCartThunk } from "../../services/actions/cart_actions";
import { addFavThunk, removeFavThunk } from "../../services/actions/fav_actions";
import { checkProductInCart, checkProductInFav } from "../../utils/util_functions";
import { getCookie } from "../../utils/cookie";
import { setPrimaryKeyInProductsList } from "../../utils/util_functions";
import { MAX_PROD_IN_CART, TITLE_NOTIFICATION, TEXT_NOTIFICATION_MAX_PRODUCTS } from "../../utils/constants";
import { SET_PORTAL_API } from "../../services/actions/portal_actions";

const ProductCard = ({ product }) => {


  const dispatch = useDispatch();
  const settings = useSelector(getSettings);


  const user = useSelector(getUser);
  const cart = useSelector(getCart);
  const { favorites: favoriteProducts } = useSelector(getFavorites);

  const thisProductInCart = checkProductInCart(cart.productsInCart, product);
  const thisProductInFav = checkProductInFav(favoriteProducts, product);

  const navigate = useNavigate();

  const accessToken = getCookie('accessToken') || '';
  const refreshToken = getCookie('refreshToken') || '';

  const handleClickFavorite = (e) => {
    e.preventDefault();
    if (!thisProductInFav) {
      dispatch(
        addFavThunk(
          accessToken, refreshToken, { id: product.id }
        ));
    } else {
      dispatch(
        removeFavThunk(
          accessToken, refreshToken, { id: product.id }
        ));
    }
  }


  const handleClickCart = (e) => {

    const productInCart = { product, count: product.min_count_order, active: true };
    e.preventDefault();

    if (!thisProductInCart) {
      if (cart.productsCount >= settings.max_prod_in_cart) {
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_NOTIFICATION,
          text: TEXT_NOTIFICATION_MAX_PRODUCTS
        })
      } else {
        if (user?.loggedIn && user.is_active) {
          const newCart = [...cart.productsInCart, { product, count: product.min_count_order, active: true }];
          dispatch(
            putSyncCartThunk(
              accessToken, refreshToken,
              setPrimaryKeyInProductsList(newCart))
          );
        } else {
          dispatch({
            type: ADD_PRODUCT_TO_CART, payload: productInCart
          });
        }
      }
    } else {
      navigate('/cart');
    }
  }

  return (
    <div className={styles.card}>
      {user?.loggedIn && user.is_active &&
        <button
          className={styles.buttonFavorite}
          onClick={handleClickFavorite}
        >
          <Star className={`${styles.icon} ${thisProductInFav && styles.icon__active}`} />
        </button>
      }

      <ul className={styles.labelList}>
        {product.popular && <li className={styles.label}>Популярное</li>}
        {product.new && <li className={styles.label}>Новинка</li>}
      </ul>

      <div className={styles.img_container}>
        <img className={styles.img} src={product.image1 ? product.image1 : productImage} alt={product.name} />
      </div>
      <div className={styles.name}>{product.name}</div>
      {product.price !== product.final_price ? (
        <div className={styles.priceContainer}>
          <p className={styles.price}>{product.final_price.toLocaleString()} &#8381;</p>
          <p className={styles.priceOld}>{product.price.toLocaleString()} &#8381;</p>
        </div>
      ) : (
        <p className={styles.price}>{product.price.toLocaleString()} &#8381;</p>
      )}
      {product.available_count >= product.min_count_order ?
        <button
          className={`${styles.buttonCart} ${thisProductInCart && styles.buttonCart__inCart}`}
          onClick={handleClickCart}
        >
          {thisProductInCart ? 'В корзине' : 'Купить'}
        </button> :
        <>
          {
            (product.available_count < product.min_count_order) && product.sell_to_order ?
              <button
                className={`${styles.buttonCart} ${thisProductInCart && styles.buttonCart__inCart}`}
                onClick={handleClickCart}
              >
                {thisProductInCart ? 'В корзине' : 'Под заказ'}
              </button> :
              <p className={styles.notAvailable}>Недоступен</p>
          }
        </>
      }
    </div>
  );
}

export default ProductCard;
